export enum Role {
    ADMIN = "ADMIN",
    CUSTOMER = "CUSTOMER",
    STANDARD = "STANDARD"
}